var _rect, _rect2, _rect3, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 3.5,
    width: 12,
    height: 4,
    rx: 1.5,
    fill: "#1C1E4C",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 7.5,
    width: 12,
    height: 4,
    rx: 1.5,
    fill: "#1C1E4C",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11.5,
    width: 12,
    height: 4,
    rx: 1.5,
    fill: "#1C1E4C",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56096 9.93235H9.45053L9.35037 9.97886C8.92285 10.1774 8.44866 10.2897 7.95 10.2897C7.45176 10.2897 6.97947 10.1776 6.54885 9.9785L6.44902 9.93235H6.33904H5.97C4.04917 9.93235 2.5 11.5058 2.5 13.4341V14.3632C2.5 15.2262 3.19397 15.9353 4.06071 15.9353H11.8393C12.706 15.9353 13.4 15.2262 13.4 14.3632V13.4341C13.4 11.5058 11.8508 9.93235 9.93 9.93235H9.56096ZM7.95 10.2176C9.79349 10.2176 11.2786 8.70899 11.2786 6.85882C11.2786 5.00866 9.79349 3.5 7.95 3.5C6.10651 3.5 4.62143 5.00866 4.62143 6.85882C4.62143 8.70899 6.10651 10.2176 7.95 10.2176Z",
    fill: "#1C1E4C",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovIcon);
export default __webpack_public_path__ + "static/media/gov_icon.6e20e8ed4ec2f2b4cafccbecb3fdba06.svg";
export { ForwardRef as ReactComponent };